<template>
  <div class="tutorial">
    <div class="container text-center">
      <div class="tutorial__img-container">
        <img class="tutorial__frame" src="~assets/img/tutorial-frame.png">
        <img class="tutorial__slide" :src="'/static/img/' + slideImages[slideNo]" alt="">
      </div>
      <div class="tutorial__dialog">
        <transition name="fade">
          <h1 class="tutorial__title">{{ slideTitles[slideNo] }}</h1>
        </transition>
        <p class="tutorial__text">
          {{ slideTexts[slideNo] }}
        </p>

        <div class="dots dots--dark mb-2 text-center">
          <span v-for="item in 4" @click="slideNo = item - 1" ref="indicators" class="dots__item"
            :class="{ 'dots__item--active': item <= slideNo + 1}" :key="item.id"></span>
        </div>

        <button @click="nextSlide"
          class="custom-btn custom-btn--evalution custom-btn--wide mt-2">Next</button>
      </div>
      <router-link class="tutorial__skip" :to="{ name: 'user-details' }">SKIP</router-link>
    </div>
  </div>
</template>

<script>
import DotsNumber from '@/components/Evaluation/Dots';

export default {
  components: { DotsNumber },

  data() {
    return {
      slideNo: 0,
      slideTitles: ['Getting started', 'Five Categories to Evaluate', 'Share Your Perspective', 'See Your Results'],
      // eslint-disable-next-line
      slideTexts: [
        'To start, we ask for basic information, which will be kept anonymous and will not' +
        ' be shared with third parties.',
        'The Organomyx Assessment evaluates your organisation against the five characteristics of ' +
        'a Connective Organisation: Purpose, Ecosystems, Adaptability, Real Empowerment and Leadership.',
        'Select the response that comes to you instinctively, from your personal experience and perceptions.',
        'Your group results will be available immediately. Just provide us with your email address and we’ll' +
        ' send you the report.'],
      slideImages: ['tutorial-1.png', 'tutorial-2.png', 'tutorial-3.png', 'tutorial-4.png'],
    };
  },
  methods: {
    nextSlide() {
      if (this.slideNo < 3) {
        this.slideNo = this.slideNo + 1;
        // this.$refs.indicators[this.slideNo].classList.add('indicators__item--active');
      } else {
        this.$router.push('user-details');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.dots {
  &__item {
    background: #fff;
    display: inline-block;
    width: 8px;
    height: 8px;
    border-radius: 8px;
    margin-left: 3px;
    margin-right: 3px;
    cursor: pointer;
    &--active {
      background: #455560;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Evaluation/Tutorial.vue